import { useEffect, useState } from 'react';
import { DateRange } from 'react-day-picker';

import { addDays, subMonths } from 'date-fns';

import SessionsTable from '@/components/SessionsTable/SessionsTable';
import { Text } from '@/components/shared/Text/Text';
import { DAYS_14 } from '@/lib/constants';
import { SessionStatus } from '@/lib/types/session-status';

import { useCoaches } from './hooks/useCoaches';
import { useSessions } from './hooks/useSessions';
import { getDefaultCoaches } from './utils/utils';

const AdminSessions = () => {
  const [selectedCoachIds, setSelectedCoachIds] = useState<string[]>([]);
  const [dateRange, setDateRange] = useState<DateRange>({
    from: subMonths(new Date(), 1),
    to: addDays(new Date(), DAYS_14),
  });

  const { data: coaches = [], isLoading: isLoadingCoaches } = useCoaches();
  const { data: sessions = [], isLoading: isLoadingSessions } = useSessions(
    selectedCoachIds,
    dateRange,
  );

  useEffect(() => {
    if (coaches.length > 0 && selectedCoachIds.length === 0) {
      setSelectedCoachIds(getDefaultCoaches(coaches));
    }
  }, [coaches, selectedCoachIds.length]);

  const handleExternalFilterChange = ({
    coachIds,
    dateRange,
  }: {
    coachIds?: string[];
    dateRange?: DateRange;
  }) => {
    if (coachIds !== undefined) {
      setSelectedCoachIds(coachIds.length ? coachIds : []);
    }
    if (dateRange !== undefined) {
      setDateRange(dateRange);
    }
  };

  const filteredSessions = sessions.filter((session) => session.status !== SessionStatus.New);

  const isLoading = isLoadingCoaches || (isLoadingSessions && selectedCoachIds.length > 0);

  return (
    <div className="flex flex-col w-full">
      <Text.H3 className="mb-8">Sessions by coach</Text.H3>

      <SessionsTable
        sessions={filteredSessions}
        externalFilter={{ coachIds: selectedCoachIds, dateRange: dateRange }}
        setExternalFilter={handleExternalFilterChange}
        externalFilterData={{ coaches }}
        showStats
        isLoading={isLoading}
      />
    </div>
  );
};

export default AdminSessions;
